import { createAction, props } from "@ngrx/store";
import { IReleaseNotes } from "../../models/release-notes";
import { Update } from "@ngrx/entity";

const prefix = "[Release-Notes API]";

export const addReleaseNotesSuccess = createAction(
  `${prefix} Add Release Notes Success`,
);
export const addReleaseNotesError = createAction(
  `${prefix} Add Release Notes Error`,
);
export const getLatestReleaseNotesError = createAction(
  `${prefix} Get Latest Release Notes Error`,
);
export const getLatestReleaseNotesSuccess = createAction(
  `${prefix} Get Latest Release Notes Success`,
  props<{ latestNotes: IReleaseNotes[] }>(),
);
export const updateReleaseNotesSuccess = createAction(
  `${prefix} Update Release Notes Success`,
  props<{ releaseNote: Update<IReleaseNotes> }>(),
);
export const updateReleaseNotesError = createAction(
  `${prefix} Update Release Notes Error`,
);
